'use strict';

var chunkNPDHBOEP_js = require('./chunk-NPDHBOEP.js');
var chunkCWUMIV2K_js = require('./chunk-CWUMIV2K.js');
var chunkHUKGHOBJ_js = require('./chunk-HUKGHOBJ.js');
var l = require('react');
var w = require('styled-components');

function _interopDefault (e) { return e && e.__esModule ? e : { default: e }; }

var l__default = /*#__PURE__*/_interopDefault(l);
var w__default = /*#__PURE__*/_interopDefault(w);

var D=`
  width: 73px;
  background-color: transparent;
  border: 0.5px solid;
  border-image-slice: 1;
`,v=w__default.default.div`
${({$variant:e})=>e!==chunkCWUMIV2K_js.a.contentDivider&&`
  min-width: 300px;
  `}
  border: ${({$borderWidth:e})=>e};
  border-color: ${({$borderColor:e})=>e};
  border-style: ${({$borderStyle:e})=>e};
  width: 100%;

  .divider-content {
    max-width: ${({$maxWidth:e})=>e};
    width: auto;
    text-align: center; 
    display: inline-block; 
  }
 span {
     display: flex;
     align-items: center;
     font-size: ${({$fontSize:e})=>e};
     font-weight: ${({$fontWeight:e})=>e};
     line-height: ${({$lineHeight:e})=>e};
     color: ${({$textColor:e})=>e};

    &::before,
    &::after {
      ${({$variant:e})=>e===chunkCWUMIV2K_js.a.tertiary&&`
      flex: 1;
      content: "";
      `}
      padding: ${({$padding:e})=>e};
      background-color: ${({$borderColor:e})=>e};
      margin: ${({$marginVertical:e})=>e} ${({$marginHorizontal:e})=>e};
    }
    ${({$variant:e,$color:i,$align:t,$textColor:d})=>e===chunkCWUMIV2K_js.a.contentDivider&&`
      ${t===chunkCWUMIV2K_js.b.center&&`
        &::before, &::after {
          ${D}
          border-image: linear-gradient(90deg, rgba(255, 255, 255, 0.05) 0%, ${d||i} 100%) 1;
        }
        &::before {
          content: "";
          flex: 1;
        }
        &::after {
          content: "";
          flex: 1;
          transform: rotate(180deg);
        }
      `}
      
      ${t===chunkCWUMIV2K_js.b.left&&`
        &::before {
          content: none;
        }
        &::after {
          ${D}
          width: 194px;
          border-image: linear-gradient(90deg, rgba(255, 255, 255, 0.05) 0%, ${d||i} 100%) 1;
          transform: rotate(180deg);
          content: "";
          flex: 1;
        }
      `}
    `}
  }
`,I=({variant:e="primary",text:i="OR",color:t="",size:d="medium",align:S="center"})=>{var m,g,s,$,f,c,a,p,b,h;let{tokens:u}=chunkHUKGHOBJ_js.b(),{variants:r}=chunkNPDHBOEP_js.b(u,d,t);return l__default.default.createElement(v,{$variant:e,$color:t,$align:S,$borderColor:(m=r[e])==null?void 0:m.borderColor,$borderStyle:r[e].borderStyle,$fontSize:(g=r[e])==null?void 0:g.fontSize,$textColor:(s=r[e])==null?void 0:s.textColor,$fontWeight:($=r[e])==null?void 0:$.fontWeight,$borderWidth:(f=r[e])==null?void 0:f.borderWidth,$marginHorizontal:(c=r[e])==null?void 0:c.marginHorizontal,$marginVertical:(a=r[e])==null?void 0:a.marginVertical,$padding:(p=r[e])==null?void 0:p.padding,$lineHeight:(b=r[e])==null?void 0:b.lineHeight,$maxWidth:(h=r[e])==null?void 0:h.maxWidth},e===chunkCWUMIV2K_js.a.tertiary||e===chunkCWUMIV2K_js.a.contentDivider?l__default.default.createElement("span",null,l__default.default.createElement("div",{className:"divider-content"},i)):null)};

exports.a = I;
